<template>
  <div>
    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="agent_bill_id"
    >
      <div slot="item_no" slot-scope="item_no, record">
        <div v-if="isShowMenu('agent_purchase_items/show')">
          <a @click="showInfoModal(record.purchase_item_id)">{{ item_no }}</a>
        </div>
        <div v-else>
          {{ item_no }}
        </div>
      </div>

      <span slot="actions" slot-scope="text, record">
        <a-space>
          <a v-if="isHasAdjustPermission" @click="showAdjustModal(record.agent_bill_id)">调账</a>
          <a @click="showHistoryModal(record.agent_bill_id)">历史</a>
        </a-space>
      </span>
    </a-table>
    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <show-agent-purchase-item
      v-if="isShowInfoModal"
      :visible.sync="isShowInfoModal"
      :id="showingId"
    />

    <show-agent-bill-changed-history
      v-if="isShowHistoryModal"
      :visible.sync="isShowHistoryModal"
      :id="showingHistoryAgentBillId"
    />

    <adjust-agent-bill
      v-if="isShowAdjustModal"
      :visible.sync="isShowAdjustModal"
      :agent-bill-id="showingId"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { findProfilePurchaseBills } from '@/api/agent_monthly_bill'
import { hasPermission } from '@/utils/permission'
import { formatBigNumber, formatCurrency } from '@/utils/filter'

export default {
  name: 'AgentProfilePurchaseBillList',
  components: {
    Pagination,
    ShowAgentPurchaseItem: () => import('@/views/agent_monthly_bills/purchase/Show'),
    ShowAgentBillChangedHistory: () => import('@/views/agent_bill_changed_histories/index'),
    AdjustAgentBill: () => import('@/views/agent_monthly_bills/Adjust')
  },
  props: {
    billId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowInfoModal: false,
      isShowHistoryModal: false,
      isShowAdjustModal: false,
      showingId: 0,
      showingHistoryAgentBillId: 0,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    columns() {
      return [
        { title: '项目批次', dataIndex: 'item_no', scopedSlots: { customRender: 'item_no' }, width: 235 },
        { title: '账单时间', dataIndex: 'bill_time', width: 200 },
        { title: 'Profile商品', dataIndex: 'agents_product_name', width: 220 },
        { title: '采购数量', dataIndex: 'product_count', width: 100, customRender: formatBigNumber },
        { title: '单价(元)', dataIndex: 'product_price', width: 100, customRender: formatCurrency },
        { title: '商品费用(元)', dataIndex: 'product_fee', width: 120, customRender: formatCurrency },
        { title: '快递费(元)', dataIndex: 'shipping_fee', width: 100, customRender: formatCurrency },
        { title: '账单金额(元)', dataIndex: 'total_fee', width: 120, customRender: formatCurrency },
        { title: '备注', dataIndex: 'remark', width: 100, ellipsis: true },
        { title: '操作', dataIndex: 'actions', key: 'action', width: 80, scopedSlots: { customRender: 'actions' }}
      ]
    },
    isHasAdjustPermission() {
      return hasPermission('agent_bills/adjust')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },
    showHistoryModal(agentBillId) {
      this.isShowHistoryModal = true
      this.showingHistoryAgentBillId = agentBillId
    },
    showInfoModal(recordId) {
      this.showingId = recordId
      this.isShowInfoModal = true
    },
    showAdjustModal(id) {
      this.showingId = id
      this.isShowAdjustModal = true
    },
    fetchData() {
      this.loading = true
      findProfilePurchaseBills(this.billId, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
